import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './FromUndergroundTime.css';
import { ETransportType } from '../../../../types/transportType';

interface IFromUndergroundProps {
  transportType: ETransportType;
  timeTo: string;
}

export const FromUndergroundTime: React.FC<IFromUndergroundProps> = ({ transportType, timeTo }) => {
  const Icon = transportType === ETransportType.Walk ? IconMapWalk16 : IconMapCar16;

  return (
    <div className={styles['distance']}>
      <div className={styles['icon']}>
        <Icon color={'icon-secondary-default'} />
      </div>
      <UIText2 color={'text-secondary-default'}>{timeTo}</UIText2>
    </div>
  );
};
